import { useState } from "react";
import { WhatsappLogo, Phone, EnvelopeSimple, Plus, X } from "@phosphor-icons/react";
import { site } from "../../data/content";

export const FloatingCTAs = () => {
    const [open, setOpen] = useState(false);
    const allActions = [
        { icon: WhatsappLogo, label: "WhatsApp", href: site.whatsapp ? `https://wa.me/${site.whatsapp}?text=Hello%20FRONTX,%20I%20have%20a%20manpower%20requirement.` : null, cls: "bg-[#25D366] hover:bg-[#1ebe5b]", testid: "cta-whatsapp" },
        { icon: Phone, label: "Call", href: site.phoneRaw ? `tel:${site.phoneRaw}` : null, cls: "bg-brand hover:bg-brand-dark", testid: "cta-call" },
        { icon: EnvelopeSimple, label: "Email", href: `mailto:${site.email}`, cls: "bg-navy hover:bg-navy-deep", testid: "cta-email" },
    ];
    const actions = allActions.filter((a) => a.href);

    return (
        <div className="fixed bottom-6 right-5 z-50 flex flex-col items-end gap-3" data-testid="floating-ctas">
            {open &&
                actions.map((a) => (
                    <a
                        key={a.label}
                        href={a.href}
                        target={a.href.startsWith("http") ? "_blank" : undefined}
                        rel="noopener noreferrer"
                        data-testid={a.testid}
                        className={`group flex items-center gap-3 pl-4 pr-2 py-2 rounded-full text-white shadow-lg ${a.cls} transition-transform duration-200 hover:-translate-x-1`}
                    >
                        <span className="text-sm font-semibold">{a.label}</span>
                        <span className="h-9 w-9 rounded-full bg-white/20 grid place-items-center">
                            <a.icon size={20} weight="fill" />
                        </span>
                    </a>
                ))}
            <button
                onClick={() => setOpen((v) => !v)}
                data-testid="cta-toggle"
                aria-label="Contact options"
                className="h-14 w-14 rounded-full bg-brand text-white grid place-items-center shadow-xl hover:bg-brand-dark transition-colors duration-200"
            >
                {open ? <X size={26} weight="bold" /> : <Plus size={26} weight="bold" />}
            </button>
        </div>
    );
};
